/* The Node filter bar: a select navigates to its tag-filtered view. */
(function () {
	function bind() {
		var selects = document.querySelectorAll('.node-filter__select');
		for (var i = 0; i < selects.length; i++) {
			var sel = selects[i];
			if (sel.dataset.nodeBound) continue;
			sel.dataset.nodeBound = '1';
			sel.addEventListener('change', function (e) {
				if (e.target.value) {
					window.location.href = e.target.value;
				}
			});
		}
	}
	if (document.readyState !== 'loading') {
		bind();
	} else {
		document.addEventListener('DOMContentLoaded', bind);
	}
})();
